import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FilterService } from '../services/filter.service';

@Injectable({ providedIn: 'root' })
export class FilterScopeResolver implements Resolve<boolean> {
  constructor(private filterService: FilterService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // This is the new route URL about to be activated, e.g. "/municipality/applications/123"
    const cleanUrl = state.url.split('?')[0].split('#')[0]; // Remove query/hash
    const segments = cleanUrl.split('/').filter(Boolean);   // e.g. ["municipality", "applications", "123"]
    const scope = segments.slice(0, 2).join('/');           // Take up to two segments -> "municipality/applications"

    // EXACT same logic as your FilterInitializer: 
    this.filterService.setFilterScope(scope);
    this.filterService.setFilterConfig([]);

    // Return something so the resolver completes
    return true;
  }
}